/**
 * Custom Header section
 * ---------------------------------------------------------------------------
 * Extracted from sections/custom-header.liquid, where it was ~25.8 KB of inline
 * <script>. Inline scripts are parser-blocking, cannot be cached, and are
 * re-sent on every page view - and this section renders on every page.
 *
 * Initialises every instance found on the page rather than binding to one
 * section id, so the file is fetched and parsed once. The section id is read
 * from the root element's data-section-id, which the sidebar and search modal
 * lookups still need because they live outside the section root.
 *
 * Initialisation is idempotent: an already-wired element is skipped.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-section-type="custom-header"]';

  function initSection(headerWrapper) {
    if (!headerWrapper || headerWrapper.dataset.customHeaderInit === 'true') return;
    headerWrapper.dataset.customHeaderInit = 'true';

    var sectionId = headerWrapper.dataset.sectionId;



    const sidebar = document.getElementById('CustomHeaderSidebar-' + sectionId);
    const hamburgerTrigger = headerWrapper.querySelector('.custom-header__hamburger-trigger');
    const closeBtn = sidebar ? sidebar.querySelector('.custom-header__sidebar-close-btn') : null;
    const backdrop = sidebar ? sidebar.querySelector('.custom-header__sidebar-backdrop') : null;
    const isOverlay = headerWrapper.getAttribute('data-overlay') === 'true';
    const isSticky = headerWrapper.getAttribute('data-sticky') === 'true';

    // Measure header height for negative margin overlay
    function updateHeaderHeight() {
      const header = headerWrapper.querySelector('.custom-header');
      if (header && isOverlay) {
        const height = header.offsetHeight;
        headerWrapper.style.setProperty('--ch-header-height', height + 'px');
      }
    }
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    // Find Announcement Bar
    const getAnnouncementBar = function () {
      return (
        document.querySelector('.custom-announcement-bar') ||
        document.querySelector('.announcement-bar') ||
        document.querySelector('.announcement')
      );
    };

    // Open / Close Sidebar
    let closeTimeout = null;

    function openSidebar(tabHandle) {
      clearTimeout(closeTimeout);
      if (sidebar) sidebar.classList.add('is-open');
      headerWrapper.classList.add('has-sidebar-open', 'is-solid');
      if (hamburgerTrigger) hamburgerTrigger.setAttribute('aria-expanded', 'true');

      // Always reset to single bar on open!
      const sidebarPanel = sidebar ? sidebar.querySelector('.custom-header__sidebar-panel--cascading') : null;
      if (sidebarPanel) {
        sidebarPanel.classList.remove('is-tier2-open', 'is-tier3-open');
      }
      const cascadingWrap = sidebar ? sidebar.querySelector('.custom-header__cascading-wrap') : null;
      if (cascadingWrap) {
        cascadingWrap.classList.remove('has-tier2-open', 'has-tier3-open');
      }
      if (sidebar) {
        sidebar.querySelectorAll('.custom-header__tier1-item, .custom-header__tier2-item, .custom-header__tier2-panel, .custom-header__tier3-panel').forEach(el => el.classList.remove('is-active'));
      }

      if (tabHandle) {
        const matchingTier1 = sidebar.querySelector(`.custom-header__tier1-item[data-tier1-target="${tabHandle}"]`);
        if (matchingTier1) {
          matchingTier1.dispatchEvent(new MouseEvent('mouseenter'));
        }
      }
    }

    function closeSidebar(immediate) {
      clearTimeout(closeTimeout);
      const executeClose = function () {
        if (sidebar) sidebar.classList.remove('is-open');
        headerWrapper.classList.remove('has-sidebar-open');
        if (hamburgerTrigger) hamburgerTrigger.setAttribute('aria-expanded', 'false');
        if (typeof resetCascading === 'function') resetCascading();

        if (isOverlay && window.scrollY <= 10 && !headerWrapper.matches(':hover')) {
          headerWrapper.classList.remove('is-solid');
        }
      };

      if (immediate === true) {
        executeClose();
      } else {
        closeTimeout = setTimeout(executeClose, 150);
      }
    }

    // Hamburger hover & click - 1-click instant open
    if (hamburgerTrigger) {
      hamburgerTrigger.addEventListener('mouseenter', function () {
        if (window.innerWidth > 768) {
          openSidebar();
        }
      });
      hamburgerTrigger.addEventListener('mouseleave', function () {
        if (window.innerWidth > 768) {
          closeSidebar(false);
        }
      });
      hamburgerTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearTimeout(closeTimeout);
        if (sidebar && sidebar.classList.contains('is-open') && window.innerWidth <= 768) {
          closeSidebar(true);
        } else {
          openSidebar();
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeSidebar(true);
      });
    }

    if (backdrop) {
      backdrop.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeSidebar(true);
      });
    }

    // Keep sidebar open while inside on desktop
    if (sidebar) {
      sidebar.addEventListener('mouseenter', function () {
        if (window.innerWidth > 768) {
          clearTimeout(closeTimeout);
          headerWrapper.classList.add('has-sidebar-open', 'is-solid');
        }
      });
      sidebar.addEventListener('mouseleave', function () {
        if (window.innerWidth > 768) {
          closeSidebar(false);
        }
      });

      const sidebarPanel = sidebar.querySelector('.custom-header__sidebar-panel--cascading');
      const cascadingWrap = sidebar.querySelector('.custom-header__cascading-wrap');
      const tier1Items = sidebar.querySelectorAll('.custom-header__tier1-item');
      const tier2Panels = sidebar.querySelectorAll('.custom-header__tier2-panel');
      const tier2Items = sidebar.querySelectorAll('.custom-header__tier2-item');
      const tier3Panels = sidebar.querySelectorAll('.custom-header__tier3-panel');

      function resetCascading() {
        if (sidebarPanel) {
          sidebarPanel.classList.remove('is-tier2-open', 'is-tier3-open');
        }
        if (cascadingWrap) {
          cascadingWrap.classList.remove('has-tier2-open', 'has-tier3-open');
        }
        tier1Items.forEach(i => i.classList.remove('is-active'));
        tier2Items.forEach(i => i.classList.remove('is-active'));
        tier2Panels.forEach(p => p.classList.remove('is-active'));
        tier3Panels.forEach(p => p.classList.remove('is-active'));
      }

      // TIER 1: Hover/Click on Main Menu points in Column 1
      tier1Items.forEach(item => {
        const target = item.getAttribute('data-tier1-target');
        const hasChildren = item.getAttribute('data-has-children') === 'true';

        const activateTier1 = function () {
          tier1Items.forEach(i => i.classList.remove('is-active'));
          item.classList.add('is-active');

          if (hasChildren) {
            if (sidebarPanel) {
              sidebarPanel.classList.add('is-tier2-open');
              sidebarPanel.classList.remove('is-tier3-open');
            }
            if (cascadingWrap) {
              cascadingWrap.classList.add('has-tier2-open');
              cascadingWrap.classList.remove('has-tier3-open');
            }
            tier2Items.forEach(i => i.classList.remove('is-active'));

            tier2Panels.forEach(panel => {
              if (panel.getAttribute('data-tier2-panel') === target) {
                panel.classList.add('is-active');
              } else {
                panel.classList.remove('is-active');
              }
            });
            tier3Panels.forEach(p => p.classList.remove('is-active'));
          } else {
            // NO NEXT LINKS: Collapse to only single bar (260px)!
            if (sidebarPanel) {
              sidebarPanel.classList.remove('is-tier2-open', 'is-tier3-open');
            }
            if (cascadingWrap) {
              cascadingWrap.classList.remove('has-tier2-open', 'has-tier3-open');
            }
            tier2Panels.forEach(p => p.classList.remove('is-active'));
            tier3Panels.forEach(p => p.classList.remove('is-active'));
          }
        };

        item.addEventListener('mouseenter', function () {
          if (window.innerWidth > 768) {
            activateTier1();
          }
        });
        item.addEventListener('click', function (e) {
          const isMobile = window.innerWidth <= 768 || window.matchMedia('(max-width: 768px)').matches;
          if (isMobile) {
            if (hasChildren) {
              const clickedSubLink = e.target.closest('.custom-header__mobile-sublink, .custom-header__mobile-grandchild-link');
              if (!clickedSubLink) {
                e.preventDefault();
                e.stopPropagation();
                item.classList.toggle('is-expanded');
              }
            }
          } else {
            if (hasChildren) {
              e.preventDefault();
              activateTier1();
            }
          }
        });
      });

      // Mobile Grandchildren Sub-item Toggle
      sidebar.querySelectorAll('.custom-header__mobile-subitem.has-subchildren').forEach(sub => {
        sub.addEventListener('click', function (e) {
          const isMobile = window.innerWidth <= 768 || window.matchMedia('(max-width: 768px)').matches;
          if (isMobile) {
            const clickedGrandchild = e.target.closest('.custom-header__mobile-grandchild-link');
            if (!clickedGrandchild) {
              e.preventDefault();
              e.stopPropagation();
              sub.classList.toggle('is-expanded');
            }
          }
        });
      });

      // TIER 2: Hover/Click on Categories in Column 2
      function activateTier2Item(t2Item) {
        const parentList = t2Item.closest('.custom-header__tier-nav');
        if (parentList) {
          parentList.querySelectorAll('.custom-header__tier2-item').forEach(i => i.classList.remove('is-active'));
        }
        t2Item.classList.add('is-active');

        const hasChildren = t2Item.getAttribute('data-has-children') === 'true';
        const t2Target = t2Item.getAttribute('data-tier2-target');

        if (hasChildren) {
          if (sidebarPanel) {
            sidebarPanel.classList.add('is-tier3-open');
          }
          if (cascadingWrap) {
            cascadingWrap.classList.add('has-tier3-open');
          }
          tier3Panels.forEach(panel => {
            if (panel.getAttribute('data-tier3-panel') === t2Target) {
              panel.classList.add('is-active');
            } else {
              panel.classList.remove('is-active');
            }
          });
        } else {
          // NO NEXT LINKS: Hide tier 3 (stays at 2 bars)!
          if (sidebarPanel) {
            sidebarPanel.classList.remove('is-tier3-open');
          }
          if (cascadingWrap) {
            cascadingWrap.classList.remove('has-tier3-open');
          }
          tier3Panels.forEach(p => p.classList.remove('is-active'));
        }
      }

      tier2Items.forEach(item => {
        const hasChildren = item.getAttribute('data-has-children') === 'true';
        item.addEventListener('mouseenter', function () {
          activateTier2Item(item);
        });
        item.addEventListener('click', function (e) {
          if (hasChildren) {
            e.preventDefault();
            activateTier2Item(item);
          }
        });
      });
    }

    // Header hover: turns solid white
    headerWrapper.addEventListener('mouseenter', function () {
      if (isOverlay) {
        headerWrapper.classList.add('is-solid');
      }
    });
    headerWrapper.addEventListener('mouseleave', function () {
      if (isOverlay && window.scrollY <= 10 && !headerWrapper.classList.contains('has-sidebar-open')) {
        headerWrapper.classList.remove('is-solid');
      }
    });

    // Measure Natural Announcement Bar Height
    let naturalAnnHeight = 0;
    function measureNaturalAnnHeight() {
      const annBar = getAnnouncementBar();
      if (annBar && !annBar.classList.contains('cab-sticky-active')) {
        naturalAnnHeight = annBar.offsetHeight;
      }
    }
    measureNaturalAnnHeight();
    window.addEventListener('resize', measureNaturalAnnHeight);

    // ================= SCROLL BEHAVIOR: HIDE ON SCROLL DOWN, SHOW ON SCROLL UP =================
    let lastScrollY = window.scrollY;
    let ticking = false;

    function onScroll() {
      const currentScrollY = window.scrollY;
      const annBar = getAnnouncementBar();

      if (currentScrollY <= 10) {
        // AT VERY TOP: Reset everything to natural flow & transparent overlay
        headerWrapper.classList.remove('ch-sticky-active', 'ch-hidden', 'ch-visible', 'is-solid');
        headerWrapper.style.top = '';
        updateHeaderHeight();

        if (annBar) {
          annBar.classList.remove('cab-sticky-active', 'cab-hidden', 'cab-visible');
          annBar.style.top = '';
          measureNaturalAnnHeight();
        }
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // SCROLLING DOWN: Hide both header & announcement bar smoothly
        if (isSticky) {
          headerWrapper.classList.add('ch-sticky-active', 'ch-hidden', 'is-solid');
          headerWrapper.classList.remove('ch-visible');
          if (annBar) {
            annBar.classList.add('cab-sticky-active', 'cab-hidden');
            annBar.classList.remove('cab-visible');
          }
        }
      } else if (currentScrollY < lastScrollY) {
        // SCROLLING UP: Reveal both header and announcement bar together!
        if (isSticky) {
          const barHeight = naturalAnnHeight || (annBar ? annBar.offsetHeight : 0);
          if (annBar) {
            annBar.classList.add('cab-sticky-active', 'cab-visible');
            annBar.classList.remove('cab-hidden');
            annBar.style.top = '0px';
          }
          headerWrapper.classList.add('ch-sticky-active', 'ch-visible', 'is-solid');
          headerWrapper.classList.remove('ch-hidden');
          headerWrapper.style.top = barHeight + 'px';
        }
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });

    // ================= FULL-WIDTH SEARCH MODAL LOGIC =================
    const searchModal = document.getElementById('CustomHeaderSearch-' + sectionId);
    const searchTriggers = headerWrapper.querySelectorAll('.custom-header__search-trigger');
    const searchCloseBtn = searchModal ? searchModal.querySelector('.custom-header__search-close-btn') : null;
    const searchBackdrop = searchModal ? searchModal.querySelector('.custom-header__search-backdrop') : null;
    const searchInput = searchModal ? searchModal.querySelector('.custom-header__search-input') : null;
    const searchClearBtn = searchModal ? searchModal.querySelector('.custom-header__search-clear-btn') : null;
    const searchDefaultView = searchModal ? searchModal.querySelector('.custom-header__search-default-view') : null;
    const searchLiveResults = searchModal ? searchModal.querySelector('.custom-header__search-live-results') : null;
    const searchResultsGrid = searchModal ? searchModal.querySelector('.custom-header__search-results-grid') : null;
    const searchNoResults = searchModal ? searchModal.querySelector('.custom-header__search-no-results') : null;
    const searchTermDisplays = searchModal ? searchModal.querySelectorAll('.search-term-display, .search-term-empty') : [];
    const searchViewAllLink = searchModal ? searchModal.querySelector('.custom-header__search-view-all-link') : null;
    const trendingItems = searchModal ? searchModal.querySelectorAll('.custom-header__trending-item') : [];

    function openSearchModal() {
      if (!searchModal) return;
      if (sidebar && sidebar.classList.contains('is-open')) {
        closeSidebar();
      }
      headerWrapper.classList.add('has-search-open', 'is-solid');
      searchModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 150);
    }

    function closeSearchModal() {
      if (!searchModal) return;
      searchModal.classList.remove('is-open');
      headerWrapper.classList.remove('has-search-open');
      if (isOverlay && window.scrollY <= 10 && !headerWrapper.matches(':hover') && !headerWrapper.classList.contains('has-sidebar-open')) {
        headerWrapper.classList.remove('is-solid');
      }
      document.body.style.overflow = '';
    }

    searchTriggers.forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openSearchModal();
      });
    });

    if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearchModal);
    if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearchModal);

    // Escape key closes search
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchModal && searchModal.classList.contains('is-open')) {
        closeSearchModal();
      }
    });

    // Clicking trending search keywords
    trendingItems.forEach(item => {
      item.addEventListener('click', function () {
        const term = item.getAttribute('data-term') || item.textContent.trim();
        if (searchInput) {
          searchInput.value = term;
          performPredictiveSearch(term);
        }
      });
    });

    // Clear search input button
    if (searchClearBtn) {
      searchClearBtn.addEventListener('click', function () {
        if (searchInput) {
          searchInput.value = '';
          searchInput.focus();
          showDefaultSearchView();
        }
      });
    }

    function showDefaultSearchView() {
      if (searchDefaultView) searchDefaultView.style.display = 'block';
      if (searchLiveResults) searchLiveResults.style.display = 'none';
      if (searchClearBtn) searchClearBtn.style.display = 'none';
    }

    let searchDebounceTimer = null;
    function performPredictiveSearch(query) {
      const trimmed = query.trim();
      if (trimmed.length < 2) {
        showDefaultSearchView();
        return;
      }

      if (searchClearBtn) searchClearBtn.style.display = 'flex';
      if (searchDefaultView) searchDefaultView.style.display = 'none';
      if (searchLiveResults) searchLiveResults.style.display = 'block';

      searchTermDisplays.forEach(el => el.textContent = trimmed);
      if (searchViewAllLink) searchViewAllLink.href = '/search?q=' + encodeURIComponent(trimmed);

      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(function () {
        const fetchUrl = '/search/suggest.json?q=' + encodeURIComponent(trimmed) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=show&resources[options][fields]=title,body,product_type,variants.title,tag';
        fetch(fetchUrl)
          .then(res => res.json())
          .then(data => {
            const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length > 0) {
              if (searchResultsGrid) {
                searchResultsGrid.innerHTML = products.map(prod => {
                  let imgUrl = '';
                  if (prod.featured_image && typeof prod.featured_image === 'object' && prod.featured_image.url) {
                    imgUrl = prod.featured_image.url;
                  } else if (prod.image) {
                    imgUrl = prod.image;
                  } else if (typeof prod.featured_image === 'string') {
                    imgUrl = prod.featured_image;
                  }

                  let priceFormatted = '';
                  if (prod.price) {
                    const pStr = String(prod.price);
                    priceFormatted = pStr.includes('$') || pStr.includes('£') || pStr.includes('€') ? pStr : '$' + pStr;
                  }

                  return `
                    <a href="${prod.url}" class="custom-header__search-result-card">
                      <div class="custom-header__search-result-img-wrap">
                        ${imgUrl ? `<img src="${imgUrl}" alt="${(prod.title || '').replace(/"/g, '&quot;')}" class="custom-header__search-result-img" loading="lazy">` : `<div style="width:100%;height:100%;background:#f4f4f4;"></div>`}
                      </div>
                      <h4 class="custom-header__search-result-title">${prod.title || ''}</h4>
                      <p class="custom-header__search-result-price">${priceFormatted}</p>
                    </a>
                  `;
                }).join('');
              }
              if (searchResultsGrid) searchResultsGrid.style.display = 'grid';
              if (searchNoResults) searchNoResults.style.display = 'none';
            } else {
              if (searchResultsGrid) searchResultsGrid.style.display = 'none';
              if (searchNoResults) searchNoResults.style.display = 'block';
            }
          })
          .catch(() => {
            if (searchResultsGrid) searchResultsGrid.style.display = 'none';
            if (searchNoResults) searchNoResults.style.display = 'block';
          });
      }, 180);
    }

    if (searchInput) {
      searchInput.addEventListener('input', function (e) {
        performPredictiveSearch(e.target.value);
      });
    }

    // Wishlist live count sync from localStorage
    function updateWishlistCount() {
      try {
        const stored = localStorage.getItem('gym_wishlist');
        const list = stored ? JSON.parse(stored) : [];
        const count = Array.isArray(list) ? list.length : 0;
        const bubble = headerWrapper.querySelector('[data-wishlist-count]');
        if (bubble) {
          bubble.textContent = count;
          if (count > 0) {
            bubble.classList.add('is-visible');
          } else {
            bubble.classList.remove('is-visible');
          }
        }
      } catch (e) {}
    }

    updateWishlistCount();
    document.addEventListener('wishlist:updated', updateWishlistCount);
    window.addEventListener('storage', updateWishlistCount);

    // Live Cart count sync
    function updateCartCount(newCount) {
      if (typeof newCount === 'number') {
        const bubbles = headerWrapper.querySelectorAll('.custom-header__cart-bubble, [data-cart-count]');
        bubbles.forEach(bubble => {
          bubble.textContent = newCount;
          if (newCount > 0) {
            bubble.classList.add('is-visible');
            bubble.classList.remove('has-pulse');
            void bubble.offsetWidth;
            bubble.classList.add('has-pulse');
          } else {
            bubble.classList.remove('is-visible');
          }
        });
        return;
      }

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          if (cart && typeof cart.item_count === 'number') {
            const bubbles = headerWrapper.querySelectorAll('.custom-header__cart-bubble, [data-cart-count]');
            bubbles.forEach(bubble => {
              bubble.textContent = cart.item_count;
              if (cart.item_count > 0) {
                bubble.classList.add('is-visible');
                bubble.classList.remove('has-pulse');
                void bubble.offsetWidth;
                bubble.classList.add('has-pulse');
              } else {
                bubble.classList.remove('is-visible');
              }
            });
          }
        })
        .catch(() => {});
    }

    document.addEventListener('cart:updated', function (evt) {
      if (evt.detail && evt.detail.cart && typeof evt.detail.cart.item_count === 'number') {
        updateCartCount(evt.detail.cart.item_count);
      } else {
        updateCartCount();
      }
    });
    document.addEventListener('ajaxProduct:added', function () {
      updateCartCount();
    });
    document.addEventListener('cart:refresh', function () {
      updateCartCount();
    });
    document.addEventListener('cart:build', function () {
      updateCartCount();
    });

    // When cart drawer or menu closes, remove any lingering solid classes if at top of page
    function handleDrawerClose() {
      if (window.scrollY <= 10) {
        headerWrapper.classList.remove('is-solid', 'ch-sticky-active', 'ch-hidden', 'ch-visible');
      }
      if (document.activeElement && headerWrapper.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    }

    document.addEventListener('drawerClose', handleDrawerClose);
    document.addEventListener('cart:close', handleDrawerClose);
    document.addEventListener('modalClose', handleDrawerClose);
  }

  function initAll(root) {
    var scope = root || document;
    // On shopify:section:load the event target IS the section element, and
    // querySelectorAll only looks at descendants - so test the root itself too.
    if (scope.matches && scope.matches(SELECTOR)) initSection(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
